import { themeGet } from '@styled-system/theme-get';
import styled from 'styled-components';
import { Box } from '../Box/Box';
import { Button } from '../Button/Button';
export const StyledButton = /*#__PURE__*/styled(Button).withConfig({
  displayName: "FloatingActionButtonstyled__StyledButton",
  componentId: "sc-1p4gvck-0"
})(["&:hover{box-shadow:", ";}"], themeGet('shadows.overlay-lg'));
export const NotificationDot = /*#__PURE__*/styled(Box).withConfig({
  displayName: "FloatingActionButtonstyled__NotificationDot",
  componentId: "sc-1p4gvck-1"
})(["border:1px solid rgba(255,255,255,0.75);"]);